import authService from "./authService";

const API_URL = `${process.env.REACT_APP_API_URL}/product-stock-notifications`;

const productStockNotificationService = {
  subscribe: async ({ productId, email, phone }) => {
    const isLoggedIn = authService.isLoggedIn();

    const body = {
      product_id: productId,
    };

    // Guest user
    if (!isLoggedIn) {
      if (email) {
        body.email = email;
      }

      if (phone) {
        body.phone = phone;
      }
    }

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    // Logged-in user → send token
    if (isLoggedIn) {
      const token = authService.getToken();

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    const response = await fetch(API_URL, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || "Failed to subscribe for notification"
      );
    }

    return data;
  },
};

export default productStockNotificationService;